import React from "react";
import type { StrapiRichTextBlock } from "@/lib/strapi";

export function StrapiDescription({ data }: { data: string | StrapiRichTextBlock[] | null | undefined }) {
  if (!Array.isArray(data)) {
    if (typeof data === "string") {
      return <p>{data}</p>;
    }
    return null;
  }

  return (
    <>
      {data.map((block, index) => {
        if (block.type === "paragraph" && Array.isArray(block.children)) {
          return (
            <p key={index}>
              {block.children.map((child, childIndex) => {
                if (child.type === "text" && typeof child.text === "string") {
                  return child.text;
                }
                return null;
              })}
            </p>
          );
        }
        return null;
      })}
    </>
  );
}
